import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import { PersonAdd } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { colors, designTokens } from '../../theme/theme';

export default function ProfileNudgeBanner() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return null;

  // Show nudge if profile is incomplete
  const needsAvatar = !user.avatar_url;
  const needsBio = !user.bio;
  const needsIndustry = !user.industry;
  const incomplete = needsAvatar || needsBio || needsIndustry;

  if (!incomplete) return null;

  const missing = [
    needsAvatar && 'photo',
    needsBio && 'bio',
    needsIndustry && 'industry',
  ].filter(Boolean);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2, mb: 3, display: 'flex', alignItems: 'center', gap: 2,
        bgcolor: designTokens.glass.surface,
        border: `1px solid ${designTokens.glass.border}`,
        borderLeft: `3px solid ${colors.primary.main}`,
        borderRadius: `${designTokens.radius.md}px`,
      }}
    >
      <PersonAdd sx={{ color: colors.primary.main, fontSize: 28 }} />
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#FFFFFF' }}>
          Complete your profile
        </Typography>
        <Typography variant="caption" sx={{ color: colors.neutral[700] }}>
          Add your {missing.join(', ')} to help others recognize you at events
        </Typography>
      </Box>
      <Button
        size="small"
        variant="outlined"
        onClick={() => navigate('/profile')}
        sx={{ minWidth: 80 }}
      >
        Complete
      </Button>
    </Paper>
  );
}
